import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Row, Column } from 'react-foundation/lib/components/grid';

import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';

const StyledRow = styled(Row)`
	margin-bottom: 6rem;
`;

const PageContent = ({ onClick, children }) => (
	<div className="off-canvas-content">
		<Header className="menu-title-main" onClick={onClick} />
		<StyledRow>
			<Column small={12}>{React.Children.toArray(children)}</Column>
		</StyledRow>
		<Footer />
	</div>
);

PageContent.propTypes = {
	onClick: PropTypes.func,
	children: PropTypes.node
};

export default PageContent;
